<template>
  <div class="Ledger">
    <div class="page-title">{{ title }}</div>
    <div>
      <div class="inline" style="width: 300px;">
        <ACustomerSelector size="mini" buyer @select="handleSelectCustomer" />
      </div>
      <div class="inline" style="width: 200px;">
        <el-input placeholder="전화번호" :value="cutomer_tel" disabled>
          <template slot="prepend">연락처</template>
        </el-input>
      </div>
      <div class="inline ml-default" style="width: 200px;">
        <el-input placeholder="팩스" :value="cutomer_fax" disabled>
          <template slot="prepend">팩스</template>
        </el-input>
      </div>
      <div class="inline ml-default" style="width: 500px;">
        <el-input placeholder="비고" :value="cutomer_desc" disabled>
          <template slot="prepend">비고</template>
        </el-input>
      </div>
    </div>
    <div class="mt-default">
      <el-tabs type="card" v-model="active_tab" @tab-click="handleTabClick">
        <el-tab-pane label="매입" name="0">
          <BuyLedger
            ref="buy"
            v-if="buy_visible"
            :customer="customer"
            :disabled="!customer"
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
        <el-tab-pane label="결제" name="1">
          <PayLedger
            ref="pay"
            v-if="pay_visible"
            :customer="customer"
            :disabled="!customer"
            :has_grant_write="has_grant_write"
          />
        </el-tab-pane>
        <el-tab-pane label="거래" name="2">
          <ExpenseLedger
            ref="expense"
            v-if="trade_visible"
            :customer="customer"
            :disabled="!customer"
          />
        </el-tab-pane>
        <el-tab-pane label="검색" name="3">
          <SearchLedger
            ref="search"
            v-if="search_visible"
            :customer="customer"
            :disabled="!customer"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { authority_level } from "@/common/mixins/authority_level";
import BuyLedger from "./BuyLedger";
import PayLedger from "./PayLedger";
import ExpenseLedger from "./ExpenseLedger";
import SearchLedger from "./SearchLedger";

export default {
  name: "Ledger",
  mixins: [authority_level],
  components: { BuyLedger, PayLedger, ExpenseLedger, SearchLedger },
  data() {
    return {
      title: this.$t("title.buy_ledger"),
      customer: null,
      active_tab: "0",
      buy_visible: true,
      pay_visible: false,
      trade_visible: false,
      search_visible: false,
    };
  },
  computed: {
    has_grant_write() {
      return this.isWriteLevel("buy_ledger");
    },
    cutomer_tel() {
      return this.customer ? this.customer.tel : "";
    },
    cutomer_fax() {
      return this.customer ? this.customer.fax : "";
    },
    cutomer_desc() {
      return this.customer ? this.customer.desc : "";
    },
  },
  methods: {
    handleSelectCustomer(customer) {
      if (typeof customer === "object") {
        this.customer = Object.assign({}, customer);
      } else {
        this.customer = null;
      }
    },
    handleTabClick(tab) {
      switch (tab.name) {
        case "1":
          this.pay_visible = true;
          this.$nextTick(() => {
            this.$refs.pay.loadData();
          });
          break;
        case "2":
          this.trade_visible = true;
          this.$nextTick(() => {
            this.$refs.expense.loadData();
          });
          break;
        case "3":
          this.search_visible = true;
          break;
        default:
          this.$nextTick(() => {
            this.$refs.buy.loadData();
          });
          break;
      }
    },
  },
};
</script>
